import useSplitFlow from './hooks/useSplitFlow';
import SplitFlowView from './view';

export default function SplitFlow({
    receivers = [],
    invitations = [],
    projection = { receivers: {}, invitations: {} },
    currentUserEmail,
    onChangePercentile,
    onRemoveReceiver,
    onRevokeInvitation,
    onAddReceiver,
}) {
    const { nodes, edges, flowHeight } = useSplitFlow({
        receivers,
        invitations,
        projection,
        currentUserEmail,
        onChangePercentile,
        onRemoveReceiver,
        onRevokeInvitation,
        onAddReceiver,
    });

    return <SplitFlowView nodes={nodes} edges={edges} height={flowHeight} />;
}
